import { render } from "./old-book-detail.vue?vue&type=template&id=5c063546&scoped=true"
import script from "./old-book-detail.js?vue&type=script&lang=js&external"
export * from "./old-book-detail.js?vue&type=script&lang=js&external"

import "./old-book-detail.css?vue&type=style&index=0&id=5c063546&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c063546"]])

export default __exports__